var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMap = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.418 22.0483L8.27741 18.4779L2.05048 22.0362C1.5824 22.3037 1 21.9657 1 21.4266V6.44785C1 6.19588 1.13501 5.96324 1.35377 5.83823L7.89626 2.09967C8.00132 2.03702 8.12412 2.00104 8.25532 2.00104C8.37325 2.00104 8.48438 2.03011 8.58195 2.08148L15.7226 5.6518L21.9495 2.09355C22.4176 1.82607 23 2.16406 23 2.70317V17.6819C23 17.9339 22.865 18.1665 22.6462 18.2915L16.1037 22.0301C15.9987 22.0927 15.8759 22.1287 15.7447 22.1287C15.6268 22.1287 15.5156 22.0996 15.418 22.0483V22.0483ZM15.0426 6.88178L8.95745 3.83923V17.248L15.0426 20.2905V6.88178ZM16.4468 6.85531V20.2167L21.5957 17.2744V3.91306L16.4468 6.85531ZM7.55319 3.91306L2.40426 6.85531V20.2167L7.55319 17.2744V3.91306Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgMap;